module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAUVBMVEUAAAD///////////////////////////////////////////////8zMzNGRkbf39/29vZlZWU2Nja5ubmurq5VVVXl5eW7u7uhoaGLi4uBgYHMWuVVAAAADHRSTlMAPvnr59jHwolUIQFfym6cAAAApUlEQVQoz33T2w6DIAyA4baCoFTYQXd6/wddIgOLC/1vv4gECpQCemeIjPMY4NRkuWanhuaRm8b5MBz41IDViP+in871O9mQVxb/k437PrnTBBBsD20A5KPL+pCK4IVdl5gEenDSlkYdGGG3V5RqgITdOUklIGncKJVl37tl3cqyZUNrfHIubZ+6Ic/dPGAfUT0+7eC1K1MvWxsTfcD00dSHWn0OX0pFHSgPnEPHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/publicClass/kecheng_icon_drop-up.png
// module id = wVY5
// module chunks = 23